export default {
  ko_KR: {
    code: 'ko_KR',
    lang: 'ko',
    faqAlias: 'cloud',
    displayName: 'KOR',
    noticeLang: 'KOREAN'
  },
  en_US: {
    code: 'en_US',
    lang: 'en',
    faqAlias: 'cloud_en',
    displayName: 'ENG',
    noticeLang: 'ENGLISH'
  },
  ja_JP: {
    code: 'ja_JP',
    lang: 'ja',
    faqAlias: 'cloud_jp',
    displayName: 'JPN',
    noticeLang: 'JAPANESE'
  },
  zh_CN: {
    code: 'zh_CN',
    lang: 'zh',
    faqAlias: 'cloud_cn',
    displayName: 'CHN',
    noticeLang: 'CHINESE'
  }
}
